RecommendationsController.$inject= ['RecommendationsService', 'RecommendationsConfig'];
export default function RecommendationsController(RecommendationsService, RecommendationsConfig) {
    var ctrl = this;

    ctrl.$onChanges = function(changes) {
        if (changes) {
            ctrl.docid = changes.docid.currentValue;
        }
    };

    ctrl.$onInit = function() {
        load();
    };

    ////////

    function load() {
        var qs  = {
            docid: ctrl.docid,
            matrix_id: 2
        };

        console.log(qs);

        RecommendationsService.get(qs).$promise.then(function(response) {
            ctrl.response = response; 
            ctrl.content = response; 
        });
    }


}
